import React from 'react'

const ShiftMap = () => {
  return (
    <div id="shift-map"></div>
  )
}

export default ShiftMap